import { twc } from "../utils";

const StandaloneRow = twc.div`flex items-start gap-2 text-sm text-text-secondary py-2 px-1 animate-fade-in`;
const InferenceRow = twc.div`flex items-start gap-1.5 text-sm text-text-secondary py-0.5 px-1 animate-fade-in`;

type Props = {
  insight: string;
  variant?: "standalone" | "inference";
};

export function InsightIndicator({ insight, variant = "standalone" }: Props) {
  if (variant === "inference") {
    return (
      <InferenceRow>
        <span className="shrink-0">→</span>
        <span className="leading-snug">{insight}</span>
      </InferenceRow>
    );
  }

  return (
    <StandaloneRow>
      <span className="text-xs mt-0.5 opacity-60">✦</span>
      <span className="italic leading-relaxed">{insight}</span>
    </StandaloneRow>
  );
}
